module.exports = __webpack_public_path__ + "img/auto-create.9d96ede0.png";